if (!customElements.get('letter-customization')) {
  customElements.define(
    'letter-customization',
    class LetterCustomization extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.selects = Array.from(this.querySelectorAll('[data-letter-select]'));
        this.selects.forEach((select) => {
          select.addEventListener('change', () => {
            this.hideError(select);
            this.updateState();
          });
        });

        this.updateState();
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      get isComplete() {
        return this.selects.every((select) => select.value !== '');
      }

      /*
       * I bottoni di pagamento dinamici ("Compra ora") non passano dal submit del form,
       * quindi non sono intercettabili: restano disabilitati via CSS finche' entrambe le
       * lettere non sono selezionate.
       */
      updateState() {
        const complete = this.isComplete;
        this.toggleAttribute('data-letters-incomplete', !complete);
        document
          .querySelectorAll(`product-form[data-section-id="${this.sectionId}"]`)
          .forEach((productForm) => productForm.toggleAttribute('data-letters-incomplete', !complete));
      }

      validate() {
        let firstInvalid = null;

        this.selects.forEach((select) => {
          if (select.value === '') {
            this.showError(select);
            if (!firstInvalid) firstInvalid = select;
          } else {
            this.hideError(select);
          }
        });

        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus({ preventScroll: true });
        }

        return !firstInvalid;
      }

      /*
       * Le select sono associate al form principale del prodotto via attributo form.
       * La sticky add to cart bar usa un form separato: in quel caso i valori vanno
       * replicati come hidden input, altrimenti la personalizzazione andrebbe persa.
       */
      syncTo(form) {
        this.selects.forEach((select) => {
          if (select.form === form) return;

          let mirror = form.querySelector(`input[data-letter-mirror="${select.name}"]`);
          if (!mirror) {
            mirror = document.createElement('input');
            mirror.type = 'hidden';
            mirror.name = select.name;
            mirror.setAttribute('data-letter-mirror', select.name);
            form.appendChild(mirror);
          }
          mirror.value = select.value;
        });
      }

      showError(select) {
        select.setAttribute('aria-invalid', 'true');
        select.classList.add('select__select--error');
        this.errorElement(select)?.classList.remove('hidden');
      }

      hideError(select) {
        select.removeAttribute('aria-invalid');
        select.classList.remove('select__select--error');
        this.errorElement(select)?.classList.add('hidden');
      }

      errorElement(select) {
        return select.closest('.field')?.querySelector('[data-letter-error]');
      }
    }
  );
}

/*
 * Il form prodotto e' renderizzato con novalidate e product-form.js invia via fetch senza
 * validare: l'obbligatorieta' va imposta qui. Il listener e' in capture su document, cosi'
 * gira prima del listener di submit di <product-form> e puo' fermarlo.
 */
if (!window.__letterCustomizationSubmitGuard) {
  window.__letterCustomizationSubmitGuard = true;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const sectionId = form.closest('product-form')?.dataset.sectionId;
      if (!sectionId) return;

      const blocks = document.querySelectorAll(`letter-customization[data-section-id="${sectionId}"]`);
      if (!blocks.length) return;

      for (const block of blocks) {
        if (typeof block.validate !== 'function') continue;

        if (!block.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        block.syncTo(form);
      }
    },
    true
  );
}
